// @flow
export { default } from './UserProductCard';



// WEBPACK FOOTER //
// ./src/components/user/UserProductCard/index.js